/**
  Class representing a utility for resetting input fields.
  Creates a ResetInput object and initializes the resetableInputs property with all input fields that have the 'data-reset-input' attribute.
*/
class ResetInput {

  constructor() {
    this.resetableInputs = document.querySelectorAll('[data-reset-input]');
  }

  /**
    Resets the specified input field to its initial value and deactivates the specified button.
    @param {HTMLInputElement} input - The input field to reset.
    @param {HTMLButtonElement} button - The button to deactivate.
  */
  resetEvent(input, button) {
    input.value = null;
    const event = new Event('change');
    input.dispatchEvent(event);
    this.deactivateButton(button);
  }

  /**
    Activates the specified button by removing the 'hidden' class from it.
    @param {HTMLButtonElement} targetButton - The button to activate.
  */
  activateButton(targetButton) {
    targetButton.classList.remove('hidden');
  }

  /**
    Deactivates the specified button by adding the 'hidden' class to it.
    @param {HTMLButtonElement} targetButton - The button to deactivate.
  */
  deactivateButton(targetButton) {
    targetButton.classList.add('hidden');
  }

  /**
    Checks the value of the specified input field and activates or deactivates the specified button
    based on whether the input field is empty or not.
    @param {HTMLInputElement} input - The input field to check.
    @param {HTMLButtonElement} targetButton - The button to activate or deactivate.
  */
  checkInput(input, targetButton) {
    if (input.value !== null && input.value !== '') {
      this.activateButton(targetButton);
    } else {
      this.deactivateButton(targetButton);
    }
  }

  /**
    Initializes the ResetInput object by attaching event listeners to all resetable input fields and their corresponding reset buttons.
  */
  init() {
    this.resetableInputs.forEach((input) => {
      const targetButton = input.closest('.va-form-field').querySelector('.js-reset-button');
      this.checkInput(input, targetButton);
      input.addEventListener('change', (e) => {
        this.checkInput(input, targetButton);
      });
      targetButton.addEventListener('click', (e) => {
        this.resetEvent(input, targetButton);
      });
    });
  }
}

export default new ResetInput();
